module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwBAMAAAClLOS0AAAAAXNSR0IArs4c6QAAACdQTFRFAAAA////////////////////////////////////////////////rj1KOQAAAAx0Uk5TABAgMFBgj6+/z9/vGv2njgAAAGBJREFUOMtjYBgF5AEmXBI5i7GLM545bYBdYs+Zzdi1WOPSwjwAWpgrOuBgDbIWrjMoYAJcghtVYgFcgnUNikQA1vBdc+YoVldpDZgGBlwamHBpYOg5iiOVsBiMZiEyAADy9E+lXHLGXwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_overall_arrow.png
// module id = vf9k
// module chunks = 1